<div class="flex items-center pr-[18px] flex-shrink-0">
  <a routerLink="/">
    <img src="assets/images/logo-white.svg" alt="Emsys" class="h-6 w-auto block">
  </a>
</div>

@if (userName$ | async; as userName) {
  <div class="hidden md:flex items-center pr-[18px] border-r border-[#2e3e50] flex-shrink-0">
    <span class="text-white font-bold text-[15px] whitespace-nowrap">Welcome, {{ userName }}!</span>
  </div>
}

<vm-teleport name="header"/>
<dashboard-header-nav class="ml-auto"/>
